import { useQuery } from 'react-query';

import { fetchStores } from './api/store';
import { Store } from './api/types';

export const useStores = () => {
    return useQuery<Store[], Error>(['Stores'], async () => await fetchStores());
};

export const useStoreByOrganization = (organizationId: string) => {
    return useQuery<Store[], Error>(['Stores', organizationId], async () => {
        const data = await fetchStores();
        return data
            .filter((store) => store.organization === organizationId)
            .sort((a, b) => a.code.localeCompare(b.code, undefined, { sensitivity: 'base' }));
    });
};
